import { render, staticRenderFns } from "./priceProtectionCalculationTool.vue?vue&type=template&id=d97e66a0&scoped=true&"
import script from "./priceProtectionCalculationTool.vue?vue&type=script&lang=js&"
export * from "./priceProtectionCalculationTool.vue?vue&type=script&lang=js&"
import style0 from "./priceProtectionCalculationTool.vue?vue&type=style&index=0&id=d97e66a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d97e66a0",
  null
  
)

export default component.exports